import { render, staticRenderFns } from "./PopupProductDates.vue?vue&type=template&id=124bab8c&"
import script from "./PopupProductDates.vue?vue&type=script&lang=ts&"
export * from "./PopupProductDates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports